<!--
A content component for Modal to allow usage of custom buttons inside the content
as the template structure of the Footer doesn't allow flexibility of placing
custom buttons. -->
<template>
  <div ref="rootEl" class="wrapper" data-modal-primary-focus>
    <div class="content">
      <slot v-if="hasContent" name="content" />
      <slot v-else />
    </div>
    <div v-show="showTools" ref="modalFooter" class="bx--modal-footer">
      <slot v-if="hasTools" name="tools" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, useSlots, useTemplateRef } from "vue";

const slots = useSlots();

const hasContent = ref(false);
const hasTools = ref(false);
const showTools = ref(false);

const rootEl = useTemplateRef<HTMLElement>("rootEl");
const modalFooter = useTemplateRef<HTMLElement>("modalFooter");

function checkSlots() {
  hasContent.value = !!slots["content"];
  hasTools.value = !!slots["tools"];
}

function placeFooter() {
  if (!hasTools.value) return;

  const wrapper = rootEl.value;
  const footerEl = modalFooter.value;
  if (!wrapper || !footerEl) return;

  const modalContent = wrapper.parentNode ?? undefined;
  const container = modalContent?.parentNode ?? undefined;
  if (!modalContent || !container) return;

  container.insertBefore(footerEl, modalContent.nextSibling);
  showTools.value = true;
}

onMounted(() => {
  checkSlots();
  placeFooter();
});
</script>
